// src/components/ui/input.jsx

import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm text-text transition-colors",
          "border-neutral-dark/30",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-text",
          "placeholder:text-neutral-dark/60",
          "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 focus:border-primary",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-neutral-light",
          error && "border-danger focus:ring-danger",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
